import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import { Badge, CardBody } from "shards-react";
import ReactTable from "react-table";
import moment from "moment";
import ModalNotifications from "./ModalNotifications";
import * as status from "../SelectList/Status";
import { getMarkup } from "../SelectList/StatusMarkup";
import { getPaymentStatusName } from "../SelectList/PaymentsStatus";
import "../../../assets/sass/layout/react-table/react-table.scss"
import * as statuses from "../SelectList/Status";
import { getAppointment, getFakeAppointment } from "../CallFilter";
import {
    PaymentListCell,
    PractitionerCell,
    PatientCell
} from "./Cell/index";

const AppointmentsTable = ({ data, totalAppointments,  allowAccess, paramsUrl }) => {
    const [appointments, setAppointments] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [selectValue, setSelectValue] = useState('');
    const [rowRaisedDoneSaved, setRowRaisedDoneSaved] = useState([]);

    useEffect(() => {
        const raiseData = JSON.parse(localStorage.getItem("rowRaiseDone"));
        setRowRaisedDoneSaved(raiseData || []);
    }, []);

    useEffect(() => {
        const checkRemainingTime = () => {
            const currentTime = Date.now();

            const updatedRaiseData = rowRaisedDoneSaved.filter(rowRaise => {
                const timestamp = rowRaise.startTime;
                return currentTime - timestamp < 10 * 60 * 1000;
            });

            if (updatedRaiseData.length !== rowRaisedDoneSaved.length) {
                setRowRaisedDoneSaved(updatedRaiseData);
                localStorage.setItem("rowRaiseDone", JSON.stringify(updatedRaiseData));
            }
        };

        const interval = setInterval(checkRemainingTime, 1000);

        return () => clearInterval(interval);
    }, [rowRaisedDoneSaved]);

    useEffect(() => {
        setCurrentPage(0);
        setAppointments(data.appointments.data);
    }, [data])

    const handleInputChange = async (event, columnName, filterType) => {
        const searchTerm = event.target.value;

        setSelectValue(searchTerm)
        switch (filterType) {
            case "appointmentsStatus":
                paramsUrl.status = statuses.list().filter(item => item.value.includes(searchTerm));
                break;
            case "paymentsStatus":
                const filteredData = getPaymentStatusName().filter(item => item.value.includes(searchTerm));
                paramsUrl.paymentsStatus = filteredData;
                break;
        }

        const result = await getAppointment(paramsUrl);
        setAppointments(result.appointments.data);
    };

    const sendDataRaise = async (date, id, modal) => {
        const currentTime = new Date().getTime();

        let newRowRaiseDone = [...rowRaisedDoneSaved, { date, id, startTime: currentTime, modalChoice: modal }];
        localStorage.setItem("rowRaiseDone", JSON.stringify(newRowRaiseDone));
        const raiseData = JSON.parse(localStorage.getItem("rowRaiseDone"));
        setRowRaisedDoneSaved(raiseData);
    }

    const SelectColumnFilter = ({ column, options, handleInputChange }) => {

        return (
            <select
                className="searchSelect"
                onChange={event => handleInputChange(event, column, 'select')}
                value= { selectValue }
            >
                <option value= "">Toutes</option>
                {options.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        );
    };

    const handlePageChange = async (pageIndex) => {
        setIsLoading(true);
        const appointments = await getAppointment({...paramsUrl, page: pageIndex + 1});

        if (appointments) {
            setCurrentPage(pageIndex);
            setAppointments(getFakeAppointment(pageIndex).concat(appointments.appointments.data));
        } else {
            throw new Error("No data found in the response.");
        }
        setIsLoading(false);
    };

    function getClass(markup) {
        const colorsMarkup = getMarkup();
        const colorFind = colorsMarkup.find((item) => item.value === markup);

        return colorFind ? colorFind.class : '';
    }

    const renderHlcCell = (row) => {

        return (
            <div style = {{ gap: '0.2rem', maxWidth: '100px' }} className = 'd-flex'>
                { row.original.markup &&
                    <div className = {`circle-markup ${getClass(row.original.markup)}`}/>
                }
                { row.original.markup_partner &&
                    <div className = {`circle-markup ${getClass(row.original.markup_partner)}`}/>
                }
                { (row.original.new_patient && row.original.practitioner.new_patient_fee) &&
                    <div className = "circle-markup markup-percentage"/>
                }
                { row.original.patient && row.original.patient.premium &&
                    <div className = "circle-markup markup-BtoC"/>
                }
            </div>
        )
    };

    const renderDateCell = (row) => {
        const appointmentId = row.original.id;
        const date = moment(row.original.start_at);
        const formattedDate = date.format('DD/MM/YYYY [à] HH[h]mm');

        return (
            <Link
                to = { `/consultations/details/${appointmentId}` }
                style = {{ whiteSpace: 'unset' }}
                className = "table__color__links"
            >
                <span> { formattedDate } </span>
            </Link>
        );
    }

    const renderCreateDateCell = (row) => {
        const date = moment(row.original.created_at);
        const formattedDate = date.format('DD/MM/YYYY [à] HH[h]mm');

        return (
            <span> { formattedDate } </span>
        );
    };

    const renderStatusCell = (row) => {
        const statusInfo =
            status.list().find((element) =>
                element.value === row.original.status
            );
        return (
            <div>
                <Badge
                    pill
                    style = {{ whiteSpace: 'unset', background: statusInfo.color }}
                >
                    { statusInfo ? statusInfo.label : "" }
                </Badge>
            </div>
        );
    };

    const renderPaymentStatusCell = (row) => {
        return <PaymentListCell
            paymentsStatus = { row.original.payments_status }
            practitioner = { row.original.practitioner }
            appointmentAuthor = { row.original.author }
            appointmentStatus = { row.original.status }
        />;
    };

    const renderPatientCell = (row) => {
        const patient = row.original.patient ? row.original.patient : null;
        return <PatientCell patient = { patient }/>;
    };

    const renderPractitionerCell = (row) => {
        const practitioner = row.original.practitioner ? row.original.practitioner : null;
        return <PractitionerCell practitioner = { practitioner } /> ;
    };

    const renderSpecialtiesPractitionerCell = (row) => {

        const specialityName = row.original.practitioner.main_specialty ? row.original.practitioner.main_specialty.name : '';
        return  <span> { specialityName } </span>
    };

    const renderContactCell = (row) => {
        const patient = row.original.patient ? row.original.patient : null;
        const practitioner = row.original.practitioner ? row.original.practitioner : null;

        return patient && practitioner ?
            <div style = {{ whiteSpace: 'unset' }}>
                <ModalNotifications
                    sendDataRaise = { sendDataRaise }
                    appointmentId = { row.original.id }
                    patient = { patient }
                    practitioner = { practitioner }
                    allowAccess = { allowAccess }
                />
            </div>
            :
            <div></div>
        ;
    };

    const renderRaiseCell = (row) => {
        const clickedData = rowRaisedDoneSaved.find(data => data.id === row.original.id);

        return clickedData ?
            <div>
                <span> { clickedData.date } </span>
            </div> : "";
    }

    const allColumns = [
        allowAccess ? {
            Header: 'Markup',
            Cell: renderHlcCell,
            accessor: 'markup',
        } : null,
        {
            Header: 'Date de création',
            accessor: 'created_at',
            Cell: renderCreateDateCell,
            width: 70
        },
        {
            Header: 'Date de début',
            accessor: 'start_at',
            Cell: renderDateCell,
            width: 70
        },
        {
            Header: 'État du rendez-vous',
            accessor: 'status',
            Cell: row => renderStatusCell(row, 'status', 'select'),
            Filter: ({ column: { id } }) => (
                <SelectColumnFilter
                    column= { id }
                    options = { status.list() }
                    handleInputChange={event => handleInputChange(event, 'status', 'appointmentsStatus')}
                    paramsUrl = { paramsUrl }
                />
            ),
            filterable: true
        },
        {
            Header: 'Statut du paiement',
            Cell: row => renderPaymentStatusCell(row, 'payments_status', 'select'),
            accessor: 'order',
            Filter: ({ column: { id } }) => (
                <SelectColumnFilter
                    column={id}
                    options={getPaymentStatusName()}
                    handleInputChange={event => handleInputChange(event, 'payments_status', 'paymentsStatus')}
                />
            ),
            filterable: true
        },
        {
            Header: 'Nom du praticien',
            accessor: 'practitioner',
            Cell: row => renderPractitionerCell(row, 'practitioner'),
        },
        {
            Header: 'Spécialité du praticien',
            accessor: 'practitioner.main_specialty.name',
            Cell: row => renderSpecialtiesPractitionerCell(row),
            maxWidth: 100
        },
        {
            Header: 'Nom du patient',
            accessor: 'patient',
            Cell: row => renderPatientCell(row, 'patient'),
        },
        {
            Header: 'Informer le praticien et/ou le patient',
            Cell: renderContactCell,
        },
        {
            Header: 'Heure de relance',
            Cell: row => renderRaiseCell(row),
            width: 70
        },
    ];

    const columns = allColumns.filter(column => column !== null);

    return (
        <div>
            <h1 className = "ml-3"> Les rendez-vous </h1>
            {allowAccess ? (
                <div>
                    <span className = 'font-weight-bold ml-3'> Légende markup </span>
                    <div className = 'd-flex ml-3' style = {{ gap: '1rem' }}>
                        {
                            getMarkup().map((markup, index) =>
                                <div key = { index } className = 'd-flex align-items-center'>
                                    <div className= {`circle-markup mr-1 ${ markup.class }`}/>
                                    <span> { markup.label } </span>
                                </div>
                            )
                        }
                    </div>
                </div>
            ): ""}
            <CardBody>
                <ReactTable
                    style = {{ width: '100%' }}
                    showHeader = { false }
                    loading = { isLoading }
                    data = { appointments }
                    columns = { columns }
                    minRows = { 1 }
                    getTdProps ={ () => ({ style: { whiteSpace: 'wrap', padding: '1.2em 0.5em'} }) }
                    getTheadThProps={() => ({ style: { whiteSpace: 'wrap' } }) }
                    showPageSizeOptions = { false }
                    resizable = { false }
                    previousText = 'Précédent'
                    nextText = 'Suivant'
                    noDataText = 'Pas de données trouvées'
                    onPageChange = { handlePageChange }
                    pageSize = { 10 }
                    ofText = 'sur'
                    sortable = { true }
                    pages = { Math.ceil(totalAppointments / 10) }
                    page = { currentPage }
                />
            </CardBody>
        </div>
    );
};

export default AppointmentsTable;


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/AppointmentsTable/AppointmentsTable.js